// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LiveDemoError {\n  margin: 16px;\n}\n.LiveDemoError:empty {\n  height: 0;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n.LiveDemoError .Alert {\n  padding-left: 24px;\n}\n.LiveDemoError__empty {\n  height: 0;\n  padding: 0;\n  margin: 0;\n}\n.LiveDemoError__msg {\n  font-family: 'Inconsolata', 'Roboto Mono', monospace;\n}\n", ""]);
// Exports
module.exports = exports;
